define.alias("shared/utils/formatters/ig-post-from-dynamo", "media/utils/formatters/ig-post-from-dynamo");